import { useContext } from 'react';

import { ToastContext, type ToastContextValue } from './toast-context';

/** Shows a toast. Throws if used outside the provider, which is a bug. */
export function useToast(): ToastContextValue {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used inside <ToastProvider>.');
  }
  return context;
}
